<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div
        class="field"
      >
        <div
          class="control"
          :class="textAlignmentClass"
        >
          <label
            class="label RMPE-DynamicField-Label"
            :for="fieldQuestionId"
          >
            <span
              class="content"
              :class="{'RMPE-Required': question.required}"
              v-html="question.formattedLabel"
            />
          </label>

          <HintMessage :hint="question.formattedDescription" />

          <MediaMiddlePartial :layout="layout" />
        </div>
        <div
          class="RMPE-DynamicForm-SubmitContainer isNotAnswerable"
          :class="textAlignmentClass"
        >
          <button
            ref="auto-focus-target"
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
          <span
            v-if="!isTouchDevice"
            class="RMPE-CustomSubmit-Hint"
          >
            press <span class="is-family-code has-text-weight-bold ">Enter</span> <kbd>↵</kbd>
          </span>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import StatementFieldMixin from '../common/statement-field';

export default {
  mixins: [DynamicFieldMixin, StatementFieldMixin],

  computed: {
    textAlignmentClass() {
      switch (this.question.textAlign) {
        case 'text-align-center':
          return 'has-text-centered';
        case 'text-align-right':
          return 'has-text-right';
        default:
          return 'has-text-left';
      }
    },
  },

  methods: {
    goToNextQuestion() {
      this.$emit('go-to-next-question');
    },
  },
};
</script>

<style scoped lang="scss">

</style>
